<div class="header">
  <h2>{{ dialogTitle }}</h2>
  <mat-icon (click)="onNoClick()">close</mat-icon>
</div>
<mat-dialog-content>
  <div class="container">
    <mat-form-field class="mm-form-full-width" appearance="fill">
      <mat-label>Enter your message</mat-label>
      <textarea
        [rows]="5"
        matInput
        placeholder="Add your note here..."
        [formControl]="newNote"
      ></textarea>
    </mat-form-field>

    @if (quickSuggestions.length > 0) {
    <div class="quick-suggestions">
      <div class="suggestions-label">Quick suggestions:</div>
      @for (suggestion of quickSuggestions; track suggestion) {
      <button
        mat-stroked-button
        type="button"
        class="suggestion-button"
        (click)="useSuggestion(suggestion.label)"
      >
        {{ suggestion.label }}
      </button>
      }
    </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="mm-bg-pink mm-text-white mm-mt-10" (click)="onNoClick()">
    Cancel
  </button>
  <button
    mat-flat-button
    class="mm-bg-primary mm-text-white mm-mt-10"
    [disabled]="newNote.invalid"
    (click)="onSubmit()"
  >
    Okay
  </button>
</mat-dialog-actions>
